import React from 'react';
import PropTypes from 'prop-types';

import { ROUTES, CUSTOMER_DASHBOARD, DASHBOARD_DOC_REQ, LOCAL_STORAGE } from '../../../constants';
import { Table, ViewAll } from '../../shared';
import { renderWithLineBreaks, getLocalStorageItem, setLocalStorageItem } from '../../../utils';
import WithoutDoc from '../../../assets/img/without-doc.webp';
import { usePagination } from '../../../hooks';

const CustomerDashboardDocumentRequests = ({
    documentRequests,
    showViewAllButton = true,
    documentRequestsCount,
    isLoading,
}) => {
    const pagination = usePagination(documentRequests, documentRequestsCount);

    const prepareAssistantContext = () => {
        try {
            const accountId = getLocalStorageItem(LOCAL_STORAGE.ACCOUNT_ID);
            if (!accountId) return;
            const payload = {
                type: 'document_requests_dashboard',
                accountId,
                totalOutstanding: documentRequestsCount || 0,
            };
            setLocalStorageItem('ssc_ai_selection', payload);
        } catch (e) {
            // best-effort; fail silently so dashboard UX is unaffected
        }
    };

    return (
        <div className='col-12 col-xl-6 custom-col-set bottom-right position-relative'>
            <div className='h-100 card-container ssc-shadow d-flex flex-column w-100 align-items-center p-lg-4 p-3'>
                <div className='card-title-area d-flex w-100 align-items-center justify-content-between'>
                    <h5>Document Requests</h5>
                </div>
                <div className='divider w-100'></div>
                {documentRequestsCount > 0 ? (
                    <div className='w-100'>
                        <Table
                            columns={DASHBOARD_DOC_REQ}
                            data={documentRequests}
                            pagination={pagination}
                            debouncedApiCall={() => {}}
                            pageName='Document Requests'
                            tableStyle={{ maxHeight: 500 }}
                            hidePagination={true}
                            isLoading={isLoading}
                            stickyColumns={['Priority']}
                        />
                    </div>
                ) : (
                    <div className='d-flex align-items-center justify-content-center flex-column without-doc'>
                        <img
                            src={WithoutDoc}
                            alt='empty_doc'
                            width='176'
                            height='138'
                            className='img-fluid'
                        />
                        <p className='mb-0 text-center'>
                            {renderWithLineBreaks(CUSTOMER_DASHBOARD.NO_UPLOAD_REQUESTS)}
                        </p>
                    </div>
                )}

                {documentRequestsCount > 0 && (
                    <div
                        className={`view-btn d-flex ${documentRequestsCount < 20 ? 'justify-content-end' : 'justify-content-between'} w-100`}
                    >
                        {showViewAllButton && (
                            <ViewAll
                                className='ssc-card-btn2 text-nowrap'
                                navigateTo={ROUTES.CUSTOMER.DOCUMENTS}
                            />
                        )}
                        <button
                            type='button'
                            className='ssc-card-btn2 text-nowrap'
                            onClick={prepareAssistantContext}
                            title='Prime the AI assistant with your outstanding document requests. Then open the Assistant to review and plan next steps.'
                        >
                            Ask Assistant
                        </button>
                        <span
                            style={{ fontSize: '13px' }}
                            title={`Total Outstanding Document Requests: ${documentRequestsCount}`}
                        >
                            Total Outstanding : <b>{documentRequestsCount}</b>
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

CustomerDashboardDocumentRequests.propTypes = {
    documentRequests: PropTypes.array.isRequired,
    showViewAllButton: PropTypes.bool.isRequired,
};

export default CustomerDashboardDocumentRequests;
